module.exports = require("./ta-MY.js");